import { lazy, Suspense } from 'react';
import { Box, Loader, Paper, Stack, Text, Title } from '@mantine/core';
import { useFlags } from 'src/feature-flags/FlagsHook';
import TenantApiKeysManager from './TenantApiKeysManager';

const ExternalApiReference = lazy(() => import('./ExternalApiReference'));

export default function DevToolsPage() {
  const { flagEnabledExternalApiReference } = useFlags();

  return (
    <Box p="md">
      <Stack gap="lg">
        <Box>
          <Title order={3}>Dev tools</Title>
          <Text size="sm" c="dimmed">
            Developer tools for your organisation.
          </Text>
        </Box>

        <Paper withBorder radius="md" p="md">
          <Stack gap="md">
            <Text size="sm" c="dimmed">
              Manage external API keys for your organisation. Keys authenticate requests to the
              external API and are shown only once at the time of generation.
            </Text>
            <TenantApiKeysManager />
          </Stack>
        </Paper>

        {flagEnabledExternalApiReference && (
          <Paper withBorder radius="md" p="md">
            <Stack gap="md">
              <Box>
                <Title order={4}>API reference</Title>
                <Text size="sm" c="dimmed">
                  Endpoints available to your organisation&apos;s API keys.
                </Text>
              </Box>
              <Suspense fallback={<Loader size="sm" />}>
                <ExternalApiReference />
              </Suspense>
            </Stack>
          </Paper>
        )}
      </Stack>
    </Box>
  );
}
